import React from 'react';
import { CALENDAR_CURRENT_MONTH_SEARCH_PARAM } from '../config/constants';
import { doubleDigits, initiateDate } from '../../../shared/helpers/date';

const getInitialMonth = () => {
  const url = new URL(window.location.href);
  const currentMonth = url.searchParams.get(CALENDAR_CURRENT_MONTH_SEARCH_PARAM);

  if (currentMonth) {
    const parsedDate = initiateDate(currentMonth);

    return Number.isNaN(parsedDate.getTime()) ? initiateDate() : parsedDate;
  }

  return initiateDate();
};

const useCalendarDate = (): [Date, (date: Date) => void] => {
  const [date, setDateState] = React.useState<Date>(getInitialMonth());


  const setDate = React.useCallback((_date: Date) => {
    setDateState(_date);

    const month = `${_date.getFullYear()}-${doubleDigits(_date.getMonth() + 1)}`;
    const url = new URL(window.location.href);
    url.searchParams.set(CALENDAR_CURRENT_MONTH_SEARCH_PARAM, month);
    window.history.replaceState({}, '', url.toString());
  }, [setDateState]);

  return [date, setDate];
};

export default useCalendarDate;
